// extracted by mini-css-extract-plugin
module.exports = {"red":"Map_red__3qVoY","blue":"Map_blue__3r_NT","enemy":"Map_enemy__1uDjG","visited":"Map_visited__hGso1","map":"Map_map__1TEDK"};